<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-select
        v-if="signatureType === 'signature'"
        prepend-icon="create"
        :items="signatureItems"
        label="Tipo de Firma"
        @change="signatureSelected"
        required
      ></v-select>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        :counter="50"
        label="Nombre"
        required
      ></v-text-field>
      <v-text-field
        v-model="lastname"
        :rules="lastnameRules"
        :counter="50"
        label="Apellidos"
        required
      ></v-text-field>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
      <v-text-field
        v-if="isSimpleSignature"
        v-model="phone"
        :rules="phoneRules"
        label="Número de móvil"
        required
      ></v-text-field>
      <v-text-field
        v-if="signatureType === 'video'"
        v-model="nif"
        :rules="documentRules"
        label="DNI"
        required
      ></v-text-field>
      <v-checkbox
        v-if="isSimpleSignature || signatureType === 'video'"
        v-model="isAttachDocumentSelected"
        label="¿Quieres firmar uno de tus documentos?"
      ></v-checkbox>

      <v-layout
        row
        v-if="
          (isAttachDocumentSelected && !isHandWrittenSignature) ||
            signatureType === 'notification'
        "
      >
        <v-flex>
          <v-text-field
            label="Selecciona un documento PDF "
            @click="pickFile"
            :rules="[v => !!v || 'Se necesita un documento']"
            v-model="documentName"
            prepend-icon="attach_file"
            required
          ></v-text-field>
          <input
            type="file"
            style="display: none"
            ref="document"
            accept="application/pdf"
            @change="onFilePicked"
          />
        </v-flex>
      </v-layout>
      <v-select
        v-if="isHandWrittenSignature"
        v-model="select"
        :items="items"
        :rules="[v => !!v || 'Item is required']"
        label="Item"
        required
      ></v-select>
      <!-- <v-checkbox
      v-model="checkbox"
      :rules="[v => !!v || 'You must agree to continue!']"
      label="Do you agree?"
      required
    ></v-checkbox> -->
      <v-btn
        :disabled="!valid"
        round
        color="orange darken-4"
        dark
        bold
        outline
        @click="submit"
      >
        Enviar
      </v-btn>
      <v-btn round color="red darken-4" dark bold outline @click="clear"
        >Borrar</v-btn
      >
    </v-form>
    <v-snackbar
      v-model="isSnackBarVisible"
      :top="true"
      :color="snackBarColor"
      :right="true"
      :timeout="4000"
    >
      {{ snackBarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { bodyAutPlantilla } from "../utils/createLoginAutTokenEmailPlantilla";
import { body } from "../utils/createJSON";
export default {
  props: ["scrollTop", "signatureType"],
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  beforeDestroy() {
    document.body.removeAttribute("class", "noscroll");
    window.scrollTo(0, this.scrollTop);
  },
  data: () => ({
    valid: true,
    lazy: false,
    name: "",
    nameRules: [
      v => !!v || "El nombre es obligatorio",
      v =>
        (v && v.length <= 50) ||
        "El nombre tiene que ser menor de 50 caracteres"
    ],
    lastname: "",
    lastnameRules: [
      v => !!v || "Los apellidos son obligatorios",
      v =>
        (v && v.length <= 50) ||
        "Los apellidos tienen que ser menor de 50 caracteres"
    ],
    email: "",
    emailRules: [
      v => !!v || "El correo electrónico es obligatorio",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Introduce una dirección de correo electrónico válida"
    ],
    phone: "",
    phoneRules: [
      v => !!v || "El teléfono es requerido",
      v =>
        /^[0-9\-+]{9,15}$/.test(v) || "Introduce un número de teléfono válido"
    ],
    nif: "",
    documentRules: [
      v => !!v || "El número de identidad es obligatorio"
      // v => /^[0-9\][A-Z]{9,12}$/.test(v) || "Id. document number must be valid"
    ],
    select: null,
    //  signatureItems: ["Electronic Signature", "Handwritten Signature"],
    signatureItems: ["Firma con OTP", "Firma Manuscrita"],
    items: ["Contrato tipo 1", "Contrato tipo 2", "Contrato tipo 3"],
    checkbox: false,
    isAttachDocumentSelected: false,
    isSimpleSignature: false,
    isHandWrittenSignature: false,
    documentName: "",
    documentUrl: "",
    documentFile: "",
    snackBarColor: "",
    snackBarText: "",
    isSnackBarVisible: false
  }),
  methods: {
    recaptcha() {
      console.log("recaptcha clicked");
      this.$recaptchaLoaded().then(() => {
        console.log("recaptcha loaded");
        this.$recaptcha("login").then(token => {
          console.log(token); // Will print the token
        });
      });
    },
    signatureSelected(item) {
      if (item === "Electronic Signature" || item === "Firma con OTP") {
        this.isSimpleSignature = true;
        this.isHandWrittenSignature = false;
      } else if (
        item === "Handwritten Signature" ||
        item === "Firma Manuscrita"
      ) {
        this.isHandWrittenSignature = true;
        this.isSimpleSignature = false;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        // Google Analytics register events

        if (this.signatureType === "signature") {
          this.$ga.event({
            eventCategory: "SimpleSignature", // str
            eventAction: "click", // str
            eventLabel: "CreateButton", // str
            eventValue: 0 // int
          });
        } else if (this.signatureType === "notification") {
          this.$ga.event({
            eventCategory: "CertifiedNotification", // str
            eventAction: "click", // str
            eventLabel: "CreateButton", // str
            eventValue: 0 // int
          });
        }
        axios
          .post(`${process.env.VUE_APP_BASEURL}${"login"}`, {
            username: "jlcl",
            userpassword: "A6xnQhbz4Vx2HuGl4lXwZ5U2I8iziLRFnhP5eNfIRvQ="
          })
          .then(
            success => {
              this.$store.commit("setToken", success.data);
              let bodyData = Object;
              if (this.isSimpleSignature) {
                bodyData = JSON.stringify(bodyAutPlantilla());
                bodyData = bodyData.replace("##cellphone##", this.phone);
              } else if (this.isHandWrittenSignature) {
                bodyData = JSON.stringify(body());
                bodyData = bodyData.replace("##signatureType##", "BIOMETRICA");
                bodyData = bodyData.replace("##resumenif##", "N");
              } else if (this.signatureType === "video") {
                bodyData = JSON.stringify(body());
                bodyData = bodyData.replace(
                  "##signatureType##",
                  "AVANZADA_VIDEO_1PASO"
                );
                bodyData = bodyData.replace("##nif##", this.nif);
                bodyData = bodyData.replace("##resumenif##", "Y");
              }
              bodyData = bodyData.replace("##email##", this.email);
              bodyData = bodyData.replace("##name##", this.name);
              bodyData = bodyData.replace("##lastname##", this.lastname);
              bodyData = JSON.parse(bodyData);
              if (this.isAttachDocumentSelected) {
                bodyData.documents.contrato.documentB64 = this.documentUrl;
              }
              axios
                .post(
                  `${process.env.VUE_APP_BASEURL}${"create/withotpandtoken/"}${
                    this.$store.getters.domainUuid
                  }`,
                  bodyData
                )
                .then(
                  success => {
                    this.$store.commit(
                      "setESignToken",
                      success.data.loginautToken
                    );
                    this.$store.commit(
                      "setOperationUuid",
                      success.data.uuids[0]
                    );
                    this.$store.commit(
                      "setDocumentUuid",
                      success.data.documentsUuid[0]
                    );
                    this.getOperation();
                  },
                  () => {
                    this.snackBarColor = "error";
                    this.snackBarText =
                      "Ha ocurrido un error al crear la operación. Por favor, vuelva a intentarlo.";
                    this.isSnackBarVisible = true;
                  }
                );
            },
            () => {
              this.snackBarColor = "error";
              this.snackBarText =
                "Ha ocurrido un error al crear la operación. Por favor, vuelva a intentarlo.";
              this.isSnackBarVisible = true;
            }
          );
      }
    },
    getOperation() {
      axios
        .get(
          `${process.env.VUE_APP_BASEURL}${"getoperationbyuuid/"}${
            this.$store.getters.domainUuid
          }${"/"}${this.$store.getters.operationUuid}`
        )
        .then(
          success => {
            this.isLoading = false;
            this.$store.commit("setOperation", success.data);
            success.data.authPolicy.fields.forEach(element => {
              if (element.identifier === "cellphone") {
                this.$store.commit("setCellphone", element.value);
              }
              if (element.identifier === "signbox") {
                this.$store.commit("setSignBoxName", element.value);
              }
            });
            this.$store.commit(
              "setDocumentUuid",
              success.data.documents[0].documentUuid
            );
            if (this.isSimpleSignature) {
              this.$router.push({ name: "simpleSignature" });
            } else if (this.isHandWrittenSignature) {
              this.$router.push({ name: "handwrittenSignature" });
            } else if (this.signatureType === "video") {
              this.$router.push({ name: "identificationSignature" });
            }
          },
          () => {
            this.snackBarColor = "error";
            this.snackBarText =
              "Ha ocurrido un error al obtener los datos de la operación. Por favor, vuelve a intentarlo.";
            this.isSnackBarVisible = true;
          }
        );
    },
    clear() {
      this.$refs.form.reset();
    },
    pickFile() {
      this.$refs.document.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.documentName = files[0].name;
        if (this.documentName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.documentUrl = fr.result.split(",")[1];
          this.documentFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.documentName = "";
        this.documentFile = "";
        this.documentUrl = "";
      }
    }
  }
};
</script>
